import React, { useEffect, useState } from 'react';
import 'moment/locale/it';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useOfficesCities } from '../../../hooks/OfficesCities/useOfficesCities';
import { toast } from 'react-toastify';
import { UIModal, UIModalBody, UIModalButtons, UiModalInternal } from '../../utilities/Modal';
import UITypography from '../../utilities/Typography';
import { UIFormControlBox } from '../../utilities/Form';
import { UICheckbox, UIInput } from '../../utilities/Input';
import { UIButton } from '../../utilities/Button';
import { IconCheck } from '@tabler/icons-react';

const ModalOfficeCitiesAdmin = ({ modalOpen, handleModalClose, city }) => {
  const [cityData, setCityData] = useState(null);
  const { onUpdateOfficeCityAdmin, onCreateOfficeCityAdmin, onGetOfficeCityAdmin } = useOfficesCities();

  useEffect(() => {
    if (!modalOpen || !city) return;
    onGetOfficeCityAdmin({
      office_city_id: city?.id
    }).then((res) => {
      setCityData(res);
    });
  }, [city]);

  const handleSubmit = async (values) => {
    const { name, active } = values;

    if (city?.id) {
      onUpdateOfficeCityAdmin({
        office_city_id: city.id,
        office_city_data: {
          name,
          active
        }
      }).then((res) => {
        if (res?.response) {
          toast(res?.response, {
            style: {
              fontSize: '14px',
              backgroundColor: '#00e676',
              color: '#ffffff'
            }
          });
          handleInternalClose();
        }
      });
    } else {
      onCreateOfficeCityAdmin({
        office_city_data: {
          name,
          active
        }
      }).then((res) => {
        if (res?.response) {
          toast(res?.response, {
            style: {
              fontSize: '14px',
              backgroundColor: '#00e676',
              color: '#ffffff'
            }
          });
          handleInternalClose();
        }
      });
    }
  };

  const handleInternalClose = () => {
    setCityData(null);
    handleModalClose();
  };

  return (
    <UIModal open={modalOpen} onClose={handleInternalClose} allowFullScreen={true} className={'modal'}>
      <Formik
        initialValues={{
          name: cityData?.name ?? '',
          active: cityData?.active ?? false
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().max(255).required('Nome richiesto'),
          active: Yup.boolean().nullable()
        })}
        onSubmit={(values, { setErrors }) => handleSubmit(values, setErrors)}
        enableReinitialize={true}
      >
        {({ errors, touched, handleSubmit, values, setFieldValue, submitForm }) => (
          <form onSubmit={handleSubmit} id={'appointment-form'}>
            <UiModalInternal
              onClose={handleInternalClose}
              isLoading={city && cityData === null}
              containerSx={{
                width: '80%',
                maxWidth: '800px'
              }}
            >
              <UIModalBody
                sx={{
                  bgcolor: 'transparent'
                }}
              >
                <UITypography
                  title={'Dati città'}
                  size={'20px'}
                  sxCustom={{
                    textAlign: 'left',
                    color: '#101828',
                    mt: '30px',

                    py: '2px',
                    px: '20px'
                  }}
                />

                <UIFormControlBox error={Boolean(touched.name && errors.name)} label={'Nome'}>
                  <UIInput value={values.name} onChange={(e) => setFieldValue('name', e.target.value)} />
                </UIFormControlBox>
                <UIFormControlBox sx={{}}>
                  <UICheckbox
                    name={'active'}
                    label={'Attivo'}
                    checked={values?.active}
                    onChange={(event) => setFieldValue('active', event.target.checked)}
                  />
                </UIFormControlBox>
              </UIModalBody>

              <UIModalButtons>
                <UIButton type={'submit'} onClick={() => submitForm()} icon={<IconCheck stroke={'1.64'} size={'26px'} />} />
              </UIModalButtons>
            </UiModalInternal>
          </form>
        )}
      </Formik>
    </UIModal>
  );
};
export default ModalOfficeCitiesAdmin;
